import { useTranslation } from "react-i18next";
import { Button, Popconfirm, Space, Tooltip, Typography } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import SearchDataIndex from "../../../context/share/SearchDataIndex";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useMemo } from "react";

const { Text } = Typography;

export function useColumnTable(handleDelete) {
  const getDataIndex = SearchDataIndex();
  const { t } = useTranslation("global");
  const navigate = useNavigate();

  return useMemo(
    () => [
      {
        title: t("device.tableColumn.nameDevice"),
        dataIndex: "name",
        key: "name",
        width: 320,
        ellipsis: true,
        fixed: "left",
        align: "left",
        ...getDataIndex("name"),
        render: (text) => (
          <Tooltip title={text}>
            <Text strong ellipsis>
              {text || "-"}
            </Text>
          </Tooltip>
        ),
      },
      {
        title: t("device.tableColumn.eui"),
        dataIndex: "devEui",
        key: "devEui",
        width: 220,
        fixed: "left",
        align: "left",
        ...getDataIndex("devEui"),
        render: (text) => (
          <code style={{ color: "#1677ff", fontSize: 12 }}>{text}</code>
        ),
      },
      {
        title: t("device.tableColumn.storeName"),
        dataIndex: "locationName",
        key: "locationName",
        width: 220,
        ellipsis: true,
        align: "left",
        ...getDataIndex("locationName"),
      },
      {
        title: t("device.tableColumn.countyName"),
        dataIndex: "countyName",
        key: "countyName",
        width: 180,
        ellipsis: true,
        align: "left",
        ...getDataIndex("countyName"),
      },
      {
        title: t("device.tableColumn.departmentName"),
        dataIndex: "departmentName",
        key: "departmentName",
        width: 180,
        ellipsis: true,
        align: "left",
        ...getDataIndex("departmentName"),
      },
      {
        title: t("device.tableColumn.bucket"),
        dataIndex: "bucket",
        key: "bucket",
        width: 160,
        ellipsis: true,
        align: "left",
        ...getDataIndex("bucket"),
      },
      {
        title: t("device.tableColumn.application"),
        dataIndex: "application",
        key: "application",
        width: 140,
        ellipsis: true,
        align: "left",
      },
      {
        title: t("device.tableColumn.updatedAt"),
        dataIndex: "updatedAt",
        key: "updatedAt",
        width: 150,
        align: "left",
        render: (text) => (text ? dayjs(text).format("DD/MM/YYYY HH:mm") : "-"),
      },
      {
        title: t("device.tableColumn.option"),
        key: "option",
        fixed: "right",
        width: 160,
        align: "center",
        render: (_, record) => (
          <Space
            size="small"
            style={{ justifyContent: "center", width: "100%" }}
          >
            <Tooltip title={t("device.viewMetrics")}>
              <Button
                type="default"
                className="square-btn btn-outline-blue"
                icon={<InfoCircleOutlined style={{ color: "#1677ff" }} />}
                onClick={() =>
                  navigate("/metrics", { state: { device: record } })
                }
              />
            </Tooltip>
            <Tooltip title={t("device.edit")}>
              <Button
                type="default"
                className="square-btn btn-outline-green"
                icon={<EditOutlined style={{ color: "#52c41a" }} />}
                onClick={() => navigate(`/device/${record.uuid}/edit`)}
              />
            </Tooltip>
            <Popconfirm
              placement="topRight"
              title={t("device.deleteConfirm")}
              onConfirm={() => handleDelete(record.uuid)}
              okText={t("global.yes")}
              cancelText={t("global.no")}
            >
              <Tooltip title={t("device.delete")}>
                <Button
                  type="default"
                  className="square-btn btn-outline-red"
                  icon={<DeleteOutlined />}
                />
              </Tooltip>
            </Popconfirm>
          </Space>
        ),
      },
    ],
    [t, getDataIndex, handleDelete, navigate],
  );
}
